type ConcurrencyLimitOptions = {
  maxConcurrent?: number
  gapMs?: number
}

export class ConcurrencyLimit {
  private inFlight = 0
  private waitQueue: Array<() => void> = []
  private nextStartAt = 0
  private maxConcurrent: number
  private gapMs: number

  constructor({ maxConcurrent = 8, gapMs = 0 }: ConcurrencyLimitOptions = {}) {
    this.maxConcurrent = maxConcurrent
    this.gapMs = gapMs
  }

  async run<T>(operation: () => Promise<T>): Promise<T> {
    while (this.inFlight >= this.maxConcurrent) {
      await new Promise<void>(resolve => {
        this.waitQueue.push(resolve)
      })
    }

    this.inFlight += 1

    try {
      await this.waitForStartGap()
      return await operation()
    } finally {
      this.inFlight -= 1
      this.waitQueue.shift()?.()
    }
  }

  private async waitForStartGap(): Promise<void> {
    if (this.gapMs <= 0) {
      return
    }

    const current = Date.now()
    const startAt = Math.max(current, this.nextStartAt)
    this.nextStartAt = startAt + this.gapMs
    const delay = startAt - current

    if (delay > 0) {
      await new Promise<void>(resolve => {
        setTimeout(resolve, delay)
      })
    }
  }
}
